// extracted by mini-css-extract-plugin
module.exports = {"root":"styles-module--root--4xNbR","form":"styles-module--form--1Qv9W","button":"styles-module--button--2tnLy"};